function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "88px",
    viewBox: "0 0 60 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M -0.15625 -0.152344 C 19.84375 -0.152344 39.84375 -0.152344 59.84375 -0.152344 C 59.84375 28.847656 59.84375 57.847656 59.84375 86.847656 C 39.84375 86.847656 19.84375 86.847656 -0.15625 86.847656 C -0.15625 57.847656 -0.15625 28.847656 -0.15625 -0.152344 Z M -0.15625 -0.152344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 35.414062 8.117188 C 31.78125 8.007812 28.171875 8.210938 24.585938 8.730469 C 25.539062 8.316406 26.570312 8.058594 27.679688 7.964844 C 30.3125 7.710938 32.890625 7.761719 35.414062 8.117188 Z M 35.414062 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.156863%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 35.414062 8.117188 C 41.574219 9.3125 46.316406 12.582031 49.640625 17.921875 C 49.617188 18.386719 49.824219 18.695312 50.257812 18.839844 C 50.960938 20.128906 51.578125 21.457031 52.113281 22.820312 C 52.089844 23.828125 52.296875 24.746094 52.730469 25.578125 C 53.125 27.761719 53.125 29.90625 52.730469 32.011719 C 52.398438 32.96875 52.191406 33.992188 52.113281 35.074219 C 51.550781 37.707031 50.261719 39.953125 48.246094 41.816406 C 47.152344 43.71875 45.8125 45.453125 44.226562 47.023438 C 43.667969 47.921875 43.207031 48.839844 42.835938 49.78125 C 42.300781 50.476562 42.097656 51.296875 42.214844 52.230469 C 41.992188 53.871094 41.785156 55.554688 41.597656 57.285156 C 41.746094 57.683594 41.953125 58.042969 42.214844 58.355469 C 42.484375 59.5625 42.585938 60.789062 42.527344 62.035156 C 42.058594 62.550781 41.644531 63.113281 41.289062 63.71875 C 41.691406 64.421875 42.207031 65.035156 42.835938 65.554688 C 43.234375 67.019531 42.820312 68.246094 41.597656 69.230469 C 41.027344 69.578125 40.410156 69.730469 39.742188 69.691406 C 39.617188 71.207031 39.304688 72.6875 38.8125 74.132812 C 37.9375 75.710938 36.804688 77.089844 35.414062 78.269531 C 32.539062 79.570312 29.753906 79.46875 27.0625 77.964844 C 26.914062 77.53125 26.605469 77.328125 26.132812 77.351562 C 24.089844 75.320312 22.90625 72.867188 22.578125 70 C 22.265625 69.742188 21.902344 69.640625 21.496094 69.691406 C 20.972656 68.675781 20.25 67.859375 19.328125 67.242188 C 19.28125 66.519531 19.332031 65.804688 19.484375 65.097656 C 20.003906 64.632812 20.46875 64.121094 20.875 63.566406 C 20.457031 63.046875 20.042969 62.539062 19.640625 62.035156 C 19.589844 61.007812 19.640625 59.984375 19.792969 58.96875 C 20.230469 58.792969 20.488281 58.488281 20.566406 58.050781 C 20.597656 56.101562 20.492188 54.160156 20.257812 52.230469 C 20.039062 51.152344 19.730469 50.128906 19.328125 49.167969 C 18.78125 47.976562 18.007812 46.957031 17.011719 46.105469 C 14.902344 43.359375 12.941406 40.5 11.132812 37.527344 C 7.289062 25.507812 10.742188 16.265625 21.496094 9.804688 C 22.570312 9.464844 23.601562 9.109375 24.585938 8.730469 C 28.171875 8.210938 31.78125 8.007812 35.414062 8.117188 Z M 35.414062 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 47.785156 19.757812 C 47.761719 20.226562 47.96875 20.53125 48.402344 20.679688 C 49.050781 22.007812 49.515625 23.4375 49.792969 24.964844 C 50.742188 30.441406 49.816406 35.546875 47.011719 40.285156 C 44.292969 42.820312 42.023438 45.679688 40.207031 48.859375 C 39.425781 51.253906 39.0625 53.703125 39.125 56.214844 C 38.128906 56.308594 37.203125 56.207031 36.339844 55.90625 C 36.390625 51.921875 36.339844 47.941406 36.1875 43.960938 C 36.121094 43.480469 35.964844 43.074219 35.722656 42.734375 C 35.53125 39.773438 35.324219 36.808594 35.101562 33.851562 C 35.464844 33.917969 35.777344 33.816406 36.03125 33.542969 C 36.269531 32.964844 36.578125 32.453125 36.957031 32.011719 C 37.394531 31.867188 37.601562 31.5625 37.578125 31.09375 C 37.765625 30.820312 37.867188 30.515625 37.886719 30.175781 C 38.078125 30.140625 38.230469 30.039062 38.351562 29.867188 C 38.558594 28.746094 38.558594 27.621094 38.351562 26.5 C 38.230469 26.328125 38.078125 26.226562 37.886719 26.191406 C 36.53125 21.882812 33.957031 18.410156 30.15625 15.777344 C 29.972656 15.839844 29.820312 15.941406 29.691406 16.082031 C 29.597656 17.316406 29.441406 18.542969 29.226562 19.757812 C 27.941406 21.964844 26.601562 24.109375 25.207031 26.191406 C 24.691406 26.785156 24.484375 27.5 24.585938 28.335938 C 24.3125 30.671875 25.136719 32.613281 27.0625 34.15625 C 27.164062 34.617188 27.269531 35.074219 27.371094 35.535156 C 26.488281 42.394531 26.074219 49.289062 26.132812 56.214844 C 25.101562 56.214844 24.070312 56.214844 23.042969 56.214844 C 23.378906 51.203125 21.832031 46.914062 18.402344 43.347656 C 18.09375 42.835938 17.679688 42.429688 17.164062 42.121094 C 12.421875 36.304688 11.082031 29.769531 13.144531 22.515625 C 13.734375 21.449219 14.25 20.324219 14.691406 19.144531 C 18.71875 13.453125 24.285156 10.59375 31.390625 10.570312 C 35.242188 10.398438 38.746094 11.367188 41.90625 13.480469 C 44.394531 15.09375 46.355469 17.1875 47.785156 19.757812 Z M 47.785156 19.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.156863%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 38.195312 15.164062 C 38.972656 15.242188 39.695312 15.496094 40.359375 15.929688 C 41.351562 17.011719 42.433594 17.984375 43.609375 18.839844 C 43.898438 19.710938 43.746094 20.476562 43.144531 21.136719 C 42.835938 21.339844 42.527344 21.339844 42.214844 21.136719 C 40.90625 19.886719 39.460938 18.816406 37.886719 17.921875 C 37.039062 16.890625 37.140625 15.972656 38.195312 15.164062 Z M 38.195312 15.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.666667%,86.666667%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 49.640625 17.921875 C 50.074219 18.066406 50.28125 18.371094 50.257812 18.839844 C 49.824219 18.695312 49.617188 18.386719 49.640625 17.921875 Z M 49.640625 17.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(78.039216%,78.039216%,78.039216%)",
      fillOpacity: 1
    },
    d: "M 14.691406 19.144531 C 14.25 20.324219 13.734375 21.449219 13.144531 22.515625 C 13.152344 21.113281 13.667969 19.992188 14.691406 19.144531 Z M 14.691406 19.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.27451%,86.27451%,86.27451%)",
      fillOpacity: 1
    },
    d: "M 47.785156 19.757812 C 48.21875 19.902344 48.425781 20.210938 48.402344 20.679688 C 47.96875 20.53125 47.761719 20.226562 47.785156 19.757812 Z M 47.785156 19.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.823529%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 31.390625 20.984375 C 32.808594 22.238281 33.945312 23.71875 34.792969 25.425781 C 35.855469 27.847656 35.546875 30.042969 33.867188 32.011719 C 29.078125 33.898438 26.964844 32.261719 27.527344 27.109375 C 28.265625 25.234375 29.449219 23.703125 31.082031 22.515625 C 31.332031 22.035156 31.4375 21.523438 31.390625 20.984375 Z M 31.390625 20.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.156863%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 46.238281 22.820312 C 46.238281 23.535156 46.238281 24.25 46.238281 24.964844 C 45.550781 25.238281 44.878906 25.238281 44.226562 24.964844 C 43.28125 24.152344 43.226562 23.285156 44.070312 22.363281 C 44.898438 22.109375 45.621094 22.261719 46.238281 22.820312 Z M 46.238281 22.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.784314%,80.784314%,80.784314%)",
      fillOpacity: 1
    },
    d: "M 46.238281 22.820312 C 47.0625 23.535156 47.0625 24.25 46.238281 24.964844 C 46.238281 24.25 46.238281 23.535156 46.238281 22.820312 Z M 46.238281 22.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(83.137255%,83.137255%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 52.113281 22.820312 C 52.550781 23.65625 52.757812 24.574219 52.730469 25.578125 C 52.296875 24.746094 52.089844 23.828125 52.113281 22.820312 Z M 52.113281 22.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.392157%,80.392157%,80.392157%)",
      fillOpacity: 1
    },
    d: "M 25.207031 26.191406 C 25.234375 27.003906 25.027344 27.71875 24.585938 28.335938 C 24.484375 27.5 24.691406 26.785156 25.207031 26.191406 Z M 25.207031 26.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.980392%,90.980392%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 37.886719 26.191406 C 38.078125 26.226562 38.230469 26.328125 38.351562 26.5 C 38.558594 27.621094 38.558594 28.746094 38.351562 29.867188 C 38.230469 30.039062 38.078125 30.140625 37.886719 30.175781 C 38.300781 28.847656 38.300781 27.519531 37.886719 26.191406 Z M 37.886719 26.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.666667%,86.666667%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 37.578125 31.09375 C 37.601562 31.5625 37.394531 31.867188 36.957031 32.011719 C 36.9375 31.542969 37.140625 31.238281 37.578125 31.09375 Z M 37.578125 31.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.313725%,84.313725%,84.313725%)",
      fillOpacity: 1
    },
    d: "M 52.730469 32.011719 C 52.835938 33.132812 52.632812 34.15625 52.113281 35.074219 C 52.191406 33.992188 52.398438 32.96875 52.730469 32.011719 Z M 52.730469 32.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 32.628906 37.832031 C 32.628906 38.242188 32.628906 38.648438 32.628906 39.058594 C 31.597656 39.058594 30.566406 39.058594 29.535156 39.058594 C 29.671875 37.9375 29.777344 36.816406 29.84375 35.6875 C 30.671875 35.6875 31.496094 35.6875 32.320312 35.6875 C 32.226562 36.472656 32.328125 37.1875 32.628906 37.832031 Z M 32.628906 37.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 32.628906 37.832031 C 32.921875 38.265625 33.027344 38.777344 32.9375 39.363281 C 31.742188 39.460938 30.605469 39.359375 29.535156 39.058594 C 30.566406 39.058594 31.597656 39.058594 32.628906 39.058594 C 32.628906 38.648438 32.628906 38.242188 32.628906 37.832031 Z M 32.628906 37.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 32.9375 42.429688 C 32.9375 43.753906 32.9375 45.082031 32.9375 46.410156 C 32.632812 45.144531 32.53125 43.816406 32.628906 42.429688 C 31.597656 42.429688 30.566406 42.429688 29.535156 42.429688 C 29.632812 43.714844 29.53125 44.941406 29.226562 46.105469 C 29.226562 44.980469 29.226562 43.859375 29.226562 42.734375 C 29.707031 42.335938 30.324219 42.132812 31.082031 42.121094 C 31.761719 42.121094 32.378906 42.226562 32.9375 42.429688 Z M 32.9375 42.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.313725%,84.313725%,84.313725%)",
      fillOpacity: 1
    },
    d: "M 17.164062 42.121094 C 17.679688 42.429688 18.09375 42.835938 18.402344 43.347656 C 17.679688 43.246094 17.269531 42.835938 17.164062 42.121094 Z M 17.164062 42.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 32.9375 46.410156 C 32.902344 49.683594 33.007812 52.949219 33.246094 56.214844 C 31.90625 56.214844 30.566406 56.214844 29.226562 56.214844 C 29.226562 52.84375 29.226562 49.472656 29.226562 46.105469 C 29.53125 44.941406 29.632812 43.714844 29.535156 42.429688 C 30.566406 42.429688 31.597656 42.429688 32.628906 42.429688 C 32.53125 43.816406 32.632812 45.144531 32.9375 46.410156 Z M 32.9375 46.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.352941%,82.352941%,82.352941%)",
      fillOpacity: 1
    },
    d: "M 29.226562 42.734375 C 29.226562 43.859375 29.226562 44.980469 29.226562 46.105469 C 29.226562 49.472656 29.226562 52.84375 29.226562 56.214844 C 30.566406 56.214844 31.90625 56.214844 33.246094 56.214844 C 33.351562 56.214844 33.453125 56.214844 33.558594 56.214844 C 32.070312 56.515625 30.523438 56.617188 28.917969 56.519531 C 28.816406 51.871094 28.917969 47.273438 29.226562 42.734375 Z M 29.226562 42.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.54902%,92.54902%,92.54902%)",
      fillOpacity: 1
    },
    d: "M 35.722656 42.734375 C 35.964844 43.074219 36.121094 43.480469 36.1875 43.960938 C 36.339844 47.941406 36.390625 51.921875 36.339844 55.90625 C 36.105469 51.5625 35.902344 47.171875 35.722656 42.734375 Z M 35.722656 42.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588235%,90.588235%,90.588235%)",
      fillOpacity: 1
    },
    d: "M 19.328125 49.167969 C 19.730469 50.128906 20.039062 51.152344 20.257812 52.230469 C 19.574219 51.367188 19.265625 50.34375 19.328125 49.167969 Z M 19.328125 49.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.27451%,86.27451%,86.27451%)",
      fillOpacity: 1
    },
    d: "M 42.835938 49.78125 C 42.816406 50.675781 42.609375 51.492188 42.214844 52.230469 C 42.097656 51.296875 42.300781 50.476562 42.835938 49.78125 Z M 42.835938 49.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.803922%,89.803922%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 32.9375 42.429688 C 33.195312 46.972656 33.402344 51.566406 33.558594 56.214844 C 33.453125 56.214844 33.351562 56.214844 33.246094 56.214844 C 33.007812 52.949219 32.902344 49.683594 32.9375 46.410156 C 32.9375 45.082031 32.9375 43.753906 32.9375 42.429688 Z M 32.9375 42.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 39.125 61.726562 C 33.867188 61.949219 28.609375 62.050781 23.351562 62.035156 C 22.046875 61.410156 21.839844 60.539062 22.730469 59.429688 C 28.300781 59.226562 33.867188 59.226562 39.433594 59.429688 C 40.300781 60.328125 40.199219 61.09375 39.125 61.726562 Z M 39.125 61.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(77.647059%,77.647059%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 20.566406 58.050781 C 20.488281 58.488281 20.230469 58.792969 19.792969 58.96875 C 19.640625 59.984375 19.589844 61.007812 19.640625 62.035156 C 19.042969 61.226562 18.886719 60.304688 19.175781 59.277344 C 19.40625 58.585938 19.871094 58.179688 20.566406 58.050781 Z M 20.566406 58.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(78.431373%,78.431373%,78.431373%)",
      fillOpacity: 1
    },
    d: "M 42.214844 58.355469 C 42.816406 58.910156 43.128906 59.625 43.144531 60.5 C 43.164062 61.132812 42.957031 61.640625 42.527344 62.035156 C 42.585938 60.789062 42.484375 59.5625 42.214844 58.355469 Z M 42.214844 58.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.352941%,82.352941%,82.352941%)",
      fillOpacity: 1
    },
    d: "M 39.125 61.726562 C 35.941406 62.175781 32.691406 62.378906 29.382812 62.339844 C 27.316406 62.339844 25.304688 62.238281 23.351562 62.035156 C 28.609375 62.050781 33.867188 61.949219 39.125 61.726562 Z M 39.125 61.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(76.078431%,76.078431%,76.078431%)",
      fillOpacity: 1
    },
    d: "M 38.503906 64.789062 C 33.335938 64.695312 28.179688 64.800781 23.042969 65.097656 C 23.074219 64.90625 23.179688 64.753906 23.351562 64.636719 C 28.457031 64.382812 33.507812 64.433594 38.503906 64.789062 Z M 38.503906 64.789062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,98.431373%,98.431373%)",
      fillOpacity: 1
    },
    d: "M 38.503906 64.789062 C 40.078125 65.261719 40.386719 66.128906 39.433594 67.394531 C 38.136719 67.449219 36.902344 67.601562 35.722656 67.855469 C 31.496094 67.679688 27.269531 67.578125 23.042969 67.546875 C 21.804688 66.730469 21.804688 65.914062 23.042969 65.097656 C 28.179688 64.800781 33.335938 64.695312 38.503906 64.789062 Z M 38.503906 64.789062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.176471%,81.176471%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 23.042969 67.546875 C 27.269531 67.578125 31.496094 67.679688 35.722656 67.855469 C 34.902344 68.058594 34.027344 68.160156 33.09375 68.160156 C 29.6875 68.027344 26.339844 67.824219 23.042969 67.546875 Z M 23.042969 67.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.607843%,79.607843%,79.607843%)",
      fillOpacity: 1
    },
    d: "M 19.328125 67.242188 C 20.25 67.859375 20.972656 68.675781 21.496094 69.691406 C 20.328125 69.25 19.605469 68.433594 19.328125 67.242188 Z M 19.328125 67.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.823529%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 25.824219 70.609375 C 29.4375 70.984375 33.042969 70.984375 36.648438 70.609375 C 36.222656 75.734375 33.542969 77.574219 28.609375 76.125 C 28.09375 75.410156 27.472656 74.796875 26.753906 74.285156 C 26.0625 73.15625 25.753906 71.929688 25.824219 70.609375 Z M 25.824219 70.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.313725%,84.313725%,84.313725%)",
      fillOpacity: 1
    },
    d: "M 26.132812 77.351562 C 26.605469 77.328125 26.914062 77.53125 27.0625 77.964844 C 26.589844 77.984375 26.28125 77.78125 26.132812 77.351562 Z M 26.132812 77.351562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.de96e8b151c3bb392bc82106895ea92e.svg";
export { ForwardRef as ReactComponent };